import React from 'react';
import PropTypes from 'prop-types';

import './style.scss';

const Root = ({ children }) => {
	return <div className="root">{children}</div>;
};

Root.propTypes = {
	children: PropTypes.node.isRequired
};

export default Root;
